import React from "react";
import { components } from "react-select";

const HighlightOptions = (props) => {
    const { data, selectProps } = props;
    const inputValue = selectProps.inputValue || ""; // Get inputValue from selectProps
    const label = data.label || "";

    if (!inputValue) return <components.Option {...props}>{label}</components.Option>;

    // Use regex to match and highlight input characters
    const regex = new RegExp(`(${inputValue})`, "gi");
    const parts = label.split(regex);

    return (
        <components.Option {...props}>
            {parts.map((part, index) =>
                part.toLowerCase() === inputValue.toLowerCase() ? (
                    <span key={index} style={{ backgroundColor: "yellow", fontWeight: "bold" }}>
                        {part}
                    </span>
                ) : (
                    part
                )
            )}
        </components.Option>
    );
};

export default HighlightOptions;
